import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import ArticleBody from '../ArticleBody';
import messages from '../../../messages';
const StartingAMentalHealthConversation = () => (
  <div>
    <ArticleBody>
      <FormattedHTMLMessage
        tagName="p"
        {...messages.mentalHealthConversationBody}
      />
    </ArticleBody>
  </div>
);

StartingAMentalHealthConversation.propTypes = {};

export default StartingAMentalHealthConversation;
